var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import MiniDrawer from '../components/Header';
import { Box, Button, Stack, Typography } from '@mui/material';
import ListAndView from '../components/elements/ListAndView';
import FieldSubsectionList from '../components/dataentry/FieldSubsectionList';
import TechCardEntryTable from '../components/dataentry/TechCardEntryTable';
import AgrochemEntryTable from '../components/dataentry/AgrochemEntryTable';
import { useOnboarding } from '../components/onboarding/OnboardingProvider';
const DataEntry = (_a) => {
    var props = __rest(_a, []);
    const { hasTask, startTask } = useOnboarding();
    const maxNameLength = 43;
    const [field, setField] = React.useState(null);
    const [subsection, setSubsection] = React.useState(null);
    const list = React.useRef(null);
    return (React.createElement(MiniDrawer, { type: 'data-entry' },
        React.createElement(Stack, { spacing: 0, sx: {
                padding: '0px',
                height: 'calc(100vh - 48px)',
                minHeight: 0,
                flex: '0 0 auto',
                pt: '0px'
            } },
            React.createElement(Box, { sx: { flex: '1 1 0%', minHeight: 0, minWidth: 0, overflow: 'hidden' } },
                React.createElement(ListAndView, { leftWidth: 220, resizable: true, left: React.createElement(Box, { "data-onboarding-anchor": "data-entry-fields", sx: { height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' } },
                        React.createElement(Box, { sx: {
                                flex: '1 1 auto',
                                minHeight: 0,
                                overflowY: 'auto',
                                "&::-webkit-scrollbar": { width: 8 },
                                "&::-webkit-scrollbar-track": { backgroundColor: "#F1F1F1" },
                                "&::-webkit-scrollbar-thumb": { backgroundColor: "#C1C1C1", borderRadius: 2 }
                            } },
                            React.createElement(FieldSubsectionList, { ref: list, token: props.token, select: (f, s) => { setField(f); setSubsection(s); } }))), view: React.createElement(Box, { "data-onboarding-anchor": "data-entry-workspace", sx: { height: '100%', minHeight: 0, minWidth: 0, width: '100%', maxWidth: '100%', overflow: 'hidden' } },
                        field && subsection === 'techcard' && (React.createElement(TechCardEntryTable, { token: props.token, fieldId: field.id, fieldName: field.name })),
                        field && subsection === 'agrochem' && (React.createElement(AgrochemEntryTable, { token: props.token, fieldId: field.id, fieldName: field.name })),
                        !field && (React.createElement(Box, { sx: { p: 3 } },
                            React.createElement(Typography, { color: "text.secondary" }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0438 \u0440\u0430\u0437\u0434\u0435\u043B \u0441\u043B\u0435\u0432\u0430."),
                            hasTask('open-data') && React.createElement(Button, { size: "small", onClick: () => startTask('open-data'), sx: { mt: 1, px: 0 } }, "\u041A\u0430\u043A \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u043F\u043E\u043B\u044F")))) })))));
};
export default DataEntry;
